import { z } from 'zod';

export const Currency = z.object({
  id: z.string().default(''),
  name: z.string().default(''),
  enabled: z.boolean().default(true),
  latestCurrencyRateByUSD: z.union([z.string(), z.number()]).nullable().default(null),
  createdAt: z.string().default(''),
  updatedAt: z.string().default(''),
});
export type CurrencyType = z.infer<typeof Currency>;
